<script setup lang="ts">
import { expandLinks, items } from '~/components/navbar';
const itemsExpanded = expandLinks(items).filter(
  ({ link }) => link !== '#kontakt',
);
</script>

<template>
  <FooterContentSection heading="Rychlé odkazy">
    <div class="gap-r2 text-client-gray-darker flex flex-col">
      <AppLink
        v-for="(item, i) in itemsExpanded"
        :key="i"
        type="text"
        :to="item.link"
        :opts="{}"
      >
        {{ item.label }}
      </AppLink>
    </div>
  </FooterContentSection>
</template>
